import { createSelector } from 'reselect';

import { AppState } from '../../../../../store/models/app-state';

const getInvoiceNumberSequenceState = (state: AppState) => state.invoiceNumberSequence;

export const invoiceNumberSequencesSelector = createSelector(
    getInvoiceNumberSequenceState,
    state => state.invoiceNumberSequences
);

export const invoiceNumberSequencesAllSelector = createSelector(
    getInvoiceNumberSequenceState,
    state => state.invoiceNumberSequencesAll
);

export const invoiceNumberSequencesSupplierHistorySelector = createSelector(
    getInvoiceNumberSequenceState,
    state => state.invoiceNumberSequenceSupplierHistory
);

export const invoiceNumberSequencesRequestingSelector = createSelector(
    getInvoiceNumberSequenceState,
    state => state.requesting
);

export const invoiceNumberSequencesAvailableSuppliersSelector = createSelector(
    getInvoiceNumberSequenceState,
    state => ({
        suppliers: state.suppliers,
        formError: state.formError,
    })
);

export const invoiceNumberSequenceHistorySelector = createSelector(getInvoiceNumberSequenceState, state =>
    state.invoiceNumberSequenceHistory.sort((a, b) => {
        if (!a.prefix) return -1;
        if (!b.prefix) return 1;
        return a.prefix?.localeCompare(b.prefix);
    })
);
